import React from 'react';

const getFinalPrice = (Variables, price) => {
  return (price * (1 + Variables.CAAS_CUT)).toFixed(2);
};

export default getFinalPrice;
